module.exports = __webpack_public_path__ + "public/images/prizes/prize-maldives.e0c1d903f7c47eb368195b183f4b27ee.webp";